import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reactivateAdmin } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-114, AC-4/AC-E4: инвалидирует ['admin','admins'] после успешной
// реактивации; при 422 (already-active) тоже переинвалидирует — устраняет
// рассинхронизацию списка (AC-E4).
export function useReactivateAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adminId: number) => reactivateAdmin(adminId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
